import { connect } from 'react-redux';
import { compose } from 'recompact';

import { setSnackBarActive } from 'src/app/state/actions';

import Renderer from '.';

function makeMapStateToProps() {
  return (state, ownProps) => {
    const { snackBarType } = ownProps;
    const snackBarIsActive = state?.snackBar?.[snackBarType];

    return {
      snackBarIsActive,
    };
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchSetSnackBar: () => dispatch(setSnackBarActive(ownProps.snackBarType, false)),
});

export default compose(connect(makeMapStateToProps, mapDispatchToProps))(Renderer);
